import {Component, HostBinding, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {searchService} from '../../../services/search.service';
import {environment} from '../../../../environments/environment';
import {LocalStorageService} from 'ngx-webstorage';
import * as moment from 'moment';


@Component({
  selector: 'app-search',
  templateUrl: 'search.component.html',
  styleUrls: ['search.component.scss']
})
export class SearchComponent implements OnInit {
  @HostBinding('class.hostBackground') hostClass = false;
  public showSearch = false;
  public environment = environment;
  public items = [];
  seacrhAct = false;
  searchItem = '';
  showSearchLoader = false;

  constructor(private localSt: LocalStorageService,
              private _searchService: searchService,
              private route: ActivatedRoute,
      private sanitizer: DomSanitizer) {
      this.hostClass = true;
    if (!this.localSt.retrieve('editOrderAddingAnotherItem')) {
      this.localSt.clear('subHeaderHeading');
      this.localSt.store('subHeaderHeading', 'Search Our Entire Menu');
      this.localSt.store('backButton', {show: true, title: 'Main Menu', link: '/'});
    }
  }
  ngOnInit() {
    window.scrollTo(0, 0);
    setTimeout(_ => {
      this.localSt.store('pastOrderAgain', false);
    });
    this.showSearch = true;
    this.localSt.observe('serachBoxValue').subscribe((searchValue) => {
      this.showSearchLoader = true;
      this.seacrhAct = true;
      this.searchItem = searchValue;
      if (searchValue !== '') {
        const searchDate = moment(this.localSt.retrieve('selectedDate').fullDate).format('YYYY-MM-DD'); // Date Formated
        this._searchService.findItems(searchValue, searchDate).subscribe((res) => {
          this.items = res.data;
          this.showSearchLoader = false;
        });
      } else {
        this.showSearchLoader = false;
        this.items = [];
      }
    });
  }

  replaceWithDash(str) {
    return (str.split(' ').join('-')).replace(/\//g, '-');
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/search/search.component.ts